import { IconCalendarView, IconGridView } from 'assets/img';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, styled } from '@mui/material';
import { LwIconButton, themeConfig } from 'redesign';
import { stringifyFilters } from 'shared/utils/stringify-filters';
import { getQueryParameters } from 'shared/hooks/query-hooks/relative-path-utils';
import { usePlanningParamsContext } from '../../providers/planning-params-provider';

export const PlanningViewSwitcher = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const location = useLocation();
  const navigate = useNavigate();
  const { filters, savedParamsRef } = usePlanningParamsContext();
  const activeRoute = location.pathname.split('/').pop();

  const switchView = useCallback(() => {
    const oldViewParams = savedParamsRef.current;
    savedParamsRef.current = filters;

    const stringifiedParams = stringifyFilters(oldViewParams);

    navigate({
      pathname: activeRoute === 'calendar' ? 'table' : 'calendar',
      search: getQueryParameters(stringifiedParams),
    });
  }, [activeRoute, filters, navigate, savedParamsRef]);

  return (
    <LwIconButton
      data-testid="switch-view-icon"
      onClick={switchView}
      color="secondary"
      size="large"
      iconColorMode="stroke"
      aria-label={
        activeRoute === 'calendar'
          ? t('planning.toolbox.view-switch.table-aria-label')
          : t('planning.toolbox.view-switch.calendar-aria-label')
      }
    >
      <IconWrapper>{switcher[activeRoute === 'calendar' ? 'calendar' : 'table']}</IconWrapper>
    </LwIconButton>
  );
};

const IconWrapper = styled(Box)({
  display: 'flex',
  flexShrink: 0,
  height: themeConfig.icons.height,
  width: themeConfig.icons.width,
});

const switcher = {
  table: <IconGridView style={{ flexShrink: 0 }} />,
  calendar: <IconCalendarView style={{ flexShrink: 0 }} />,
};
